import { render, staticRenderFns } from "./vsPopup.vue?vue&type=template&id=6af6c7fd&lang=html&"
import script from "./vsPopup.vue?vue&type=script&lang=js&"
export * from "./vsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsPopup.vue"
export default component.exports